// extracted by mini-css-extract-plugin
export var chevronIcon = "_ca-2";
export var teamName = "_ca-1";
export var teamSwitcherButton = "_ca-0";